const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "核聚变2024北京站"
const desc = "We Power On! 欢迎来玩!"

const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  data: {
    newsTagId: "28608",
    ticketUrl:
      "https://show.bilibili.com/platform/detail.html?id=91014&from=pc_search",
  },
}
